export default __webpack_public_path__ + "static/media/training-illustration13.6728e8f8.png";